import {combine} from 'effector';
import {createGate} from 'effector-react';

import {
    clearWarehouseGridCache,
    fetchVirtualWarehouseGrid,
    fetchVirtualWarehouseGridUngrouped,
} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {VirtualWarehouseGridAccessors, VirtualWarehouseGridRawRow} from 'types';
import {getFirstDayOfMonth} from 'utils/date';

const domain = rootDomain.createDomain('virtualWarehouseGridListDomain');

export const CommonGate = createGate();
export const UngroupedGate = createGate();

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchVirtualWarehouseGrid,
});

export const fetchDataUngroupedFx = domain.createEffect({
    name: 'fetchDataUngroupedFx',
    handler: fetchVirtualWarehouseGridUngrouped,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearWarehouseGridCache,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({
    domain,
    defaultFilters: {
        [VirtualWarehouseGridAccessors.dateFilter]: [getFirstDayOfMonth(), new Date()],
    },
});

export const data$ = domain.createStore<VirtualWarehouseGridRawRow[] | null>(null);
export const dataUngrouped$ = domain.createStore<VirtualWarehouseGridRawRow[] | null>(null);

export const totalCount$ = domain.createStore<number>(0);
export const hasNext$ = domain.createStore<boolean>(false);

export const listState$ = combine({
    data: data$,
    dataUngrouped: dataUngrouped$,
    hasNext: hasNext$,
    totalCount: totalCount$,
    filters: filters$,
    sortings: sortings$,
    dataLoading: fetchDataFx.pending,
    dataUngroupedLoading: fetchDataUngroupedFx.pending,
    showConfigBlock: showConfigBlock$,
});
